var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"SCHOOL OPERATIONS","title":"Inventory and Assets","description":"Track school assets, stock, purchase orders, suppliers and maintenance.","count-label":"inventory tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }